<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-4 w-4"
  >
    <path
      d="M22.0253 0.6394L23.3447 1.9496C23.7567 2.362 23.9837 2.9106 23.9837 3.4969C23.9837 4.083 23.7567 4.6322 23.3447 5.0446L8.3976 19.9911L23.3613 34.9548C23.7733 35.3665 24 35.9157 24 36.5018C24 37.0878 23.7733 37.6374 23.3613 38.0494L22.0501 39.36C21.1974 40.2133 19.8084 40.2133 18.9557 39.36L1.0756 21.5439C0.6639 21.1322 0.3738 20.5836 0.3738 19.9924H0.3738C0.3738 19.3992 0.6642 18.8506 1.0756 18.4388L18.9073 0.6394C19.319 0.227 19.8842 0.0007 20.4702 0C21.0566 0 21.614 0.227 22.0253 0.6394Z"
      fill="currentColor"
    />
  </svg>
</template>
